import DownloadTextContentReportRequestModelBase from '../_generated/modelBases/download-text-content-report-request-model-base';

export default class DownloadTextContentReportRequestModel extends DownloadTextContentReportRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
